import Head from "next/head";

interface OpenGraphImage {
  alt?: string;
  height?: number;
  url: string;
  width?: number;
}

interface OpenGraph {
  description?: string;
  images?: OpenGraphImage[];
  locale?: string;
  site_name?: string;
  title?: string;
  type?: string;
  url?: string | string[];
}

interface LanguageAlternate {
  href: string;
  hrefLang: string;
}

interface SeoProps {
  description?: string;
  languageAlternates?: LanguageAlternate[];
  openGraph?: OpenGraph;
  title?: string;
}

export const NextSeo = ({
  title,
  description,
  languageAlternates,
  openGraph,
}: SeoProps) => (
  <Head>
    {title && <title>{title}</title>}
    {description && <meta content={description} name="description" />}
    {openGraph?.title && <meta content={openGraph.title} property="og:title" />}
    {openGraph?.description && (
      <meta content={openGraph.description} property="og:description" />
    )}
    {openGraph?.type && <meta content={openGraph.type} property="og:type" />}
    {openGraph?.url && (
      <meta
        content={
          Array.isArray(openGraph.url) ? openGraph.url[0] : openGraph.url
        }
        property="og:url"
      />
    )}
    {openGraph?.site_name && (
      <meta content={openGraph.site_name} property="og:site_name" />
    )}
    {openGraph?.images?.map((img) => (
      <meta content={img.url} key={img.url} property="og:image" />
    ))}
    {languageAlternates?.map((alt) => (
      <link
        href={alt.href}
        hrefLang={alt.hrefLang}
        key={alt.hrefLang}
        rel="alternate"
      />
    ))}
  </Head>
);

export const DefaultSeo = ({ title, openGraph }: SeoProps) => (
  <Head>
    {title && <title>{title}</title>}
    {openGraph?.type && <meta content={openGraph.type} property="og:type" />}
    {openGraph?.url && (
      <meta
        content={
          Array.isArray(openGraph.url) ? openGraph.url[0] : openGraph.url
        }
        property="og:url"
      />
    )}
    {openGraph?.site_name && (
      <meta content={openGraph.site_name} property="og:site_name" />
    )}
    {openGraph?.images?.map((img) => (
      <meta content={img.url} key={img.url} property="og:image" />
    ))}
  </Head>
);
